import { Steven } from 'helpers/steven';
import { type ElementClickedData } from 'types/steven';

type ValidReportEventAction =
  | 'copy_report_link'
  | 'download_report_pdf'
  | 'email_report_link'
  | 'share_report'
  | 'view_report';

type ValidPageSource = 'public' | 'private';

type LogReportElementClickedEventArgs = {
  eventAction: ValidReportEventAction;
  content: ElementClickedData['content'];
  source?: ValidPageSource | null;
};

/**
 * @param {ValidReportEventAction} eventAction - report related action taken by the user
 * @param {ElementClickedData['content']} content - passthrough for steven clicked event content
 * @param {ValidPageSource} source - optional, string representing if report page vistited was a public page or a private page requiring authorization. Defaults to 'null'
 */

const logReportElementClickedEvent = ({
  eventAction,
  content,
  source = null,
}: LogReportElementClickedEventArgs) => {
  const id = source
    ? `${source}_${eventAction}_button`
    : `${eventAction}_button`;

  const action = source
    ? `${source}_${eventAction}_clicked`
    : `${eventAction}_clicked`;

  Steven.elementClicked({
    id,
    content,
    type: 'button',
    action,
  });
};

export default logReportElementClickedEvent;
